import {createSlice} from '@reduxjs/toolkit';
import {STATE_NAMES} from './StateNames';

export enum PROJECT_PAGE_FILTER {
    STATUS = 'state',
    SERVICE = 'service',
    CSM = 'admin',
    CLIENT = 'client',
    OWNER = 'owner',
    FREELANCER = 'freelancer',
    LANGUAGE = 'language',
    TEXT_SEARCH = 'textSearch'
}

const ProjectPageFiltersSlice = createSlice({
    name: STATE_NAMES.PROJECT_PAGE_FILTERS,
    initialState: {
        [PROJECT_PAGE_FILTER.STATUS]: [],
        [PROJECT_PAGE_FILTER.SERVICE]: [],
        [PROJECT_PAGE_FILTER.CSM]: [],
        [PROJECT_PAGE_FILTER.CLIENT]: [],
        [PROJECT_PAGE_FILTER.OWNER]: [],
        [PROJECT_PAGE_FILTER.FREELANCER]: [],
        [PROJECT_PAGE_FILTER.LANGUAGE]: [],
        [PROJECT_PAGE_FILTER.TEXT_SEARCH]: ''
    },
    reducers: {
        setProjectFilters: (state, action) => {
            return {
                ...state,
                [PROJECT_PAGE_FILTER.STATUS]: action.payload[PROJECT_PAGE_FILTER.STATUS],
                [PROJECT_PAGE_FILTER.SERVICE]: action.payload[PROJECT_PAGE_FILTER.SERVICE],
                [PROJECT_PAGE_FILTER.CSM]: action.payload[PROJECT_PAGE_FILTER.CSM],
                [PROJECT_PAGE_FILTER.CLIENT]: action.payload[PROJECT_PAGE_FILTER.CLIENT],
                [PROJECT_PAGE_FILTER.OWNER]: action.payload[PROJECT_PAGE_FILTER.OWNER],
                [PROJECT_PAGE_FILTER.FREELANCER]: action.payload[PROJECT_PAGE_FILTER.FREELANCER],
                [PROJECT_PAGE_FILTER.LANGUAGE]: action.payload[PROJECT_PAGE_FILTER.LANGUAGE],
            };
        },
        setProjectFilterStatus: (state, action) => {
            return {...state, [PROJECT_PAGE_FILTER.STATUS]: action.payload};
        },
        setProjectFilterService: (state, action) => {
            return {...state, [PROJECT_PAGE_FILTER.SERVICE]: action.payload};
        },
        setProjectFilterCSM: (state, action) => {
            return {...state, [PROJECT_PAGE_FILTER.CSM]: action.payload};
        },
        setProjectFilterClient: (state, action) => {
            return {...state, [PROJECT_PAGE_FILTER.CLIENT]: action.payload};
        },
        setProjectFilterOwner: (state, action) => {
            return {...state, [PROJECT_PAGE_FILTER.OWNER]: action.payload};
        },
        setProjectFilterFreelancer: (state, action) => {
            return {...state, [PROJECT_PAGE_FILTER.FREELANCER]: action.payload};
        },
        setProjectFilterLanguage: (state, action) => {
            return {...state, [PROJECT_PAGE_FILTER.LANGUAGE]: action.payload};
        },
        removeFilterItem: (state, action) => {
            const currentValues = [...state[action.payload.filter]];

            if (currentValues.find(item => item.key === action.payload.key)) {
                currentValues.splice(currentValues.findIndex(item => item.key === action.payload.key), 1);

                return {...state, [action.payload.filter]: currentValues};
            }

            return state;
        },
        setProjectFilterTextSearch: (state, action) => {
            return {...state, [PROJECT_PAGE_FILTER.TEXT_SEARCH]: action.payload};
        }
    },
    selectors: {
        getSelectableFilters: (state) => {
            return {
                [PROJECT_PAGE_FILTER.STATUS]: state[PROJECT_PAGE_FILTER.STATUS],
                [PROJECT_PAGE_FILTER.SERVICE]: state[PROJECT_PAGE_FILTER.SERVICE],
                [PROJECT_PAGE_FILTER.CSM]: state[PROJECT_PAGE_FILTER.CSM],
                [PROJECT_PAGE_FILTER.CLIENT]: state[PROJECT_PAGE_FILTER.CLIENT],
                [PROJECT_PAGE_FILTER.OWNER]: state[PROJECT_PAGE_FILTER.OWNER],
                [PROJECT_PAGE_FILTER.FREELANCER]: state[PROJECT_PAGE_FILTER.FREELANCER],
                [PROJECT_PAGE_FILTER.LANGUAGE]: state[PROJECT_PAGE_FILTER.LANGUAGE],
            };
        },
        getProjectFilterTextSearch: (state) => {
            return state[PROJECT_PAGE_FILTER.TEXT_SEARCH];
        }
    }
});

export const {
    setProjectFilters,
    setProjectFilterStatus,
    setProjectFilterService,
    setProjectFilterCSM,
    setProjectFilterClient,
    setProjectFilterOwner,
    setProjectFilterFreelancer,
    setProjectFilterLanguage,
    removeFilterItem,
    setProjectFilterTextSearch,
} = ProjectPageFiltersSlice.actions;

export const {
    getSelectableFilters,
    getProjectFilterTextSearch
} = ProjectPageFiltersSlice.selectors;

export default ProjectPageFiltersSlice.reducer;
